<template>
  <div id="users">
    <!-- -------------------------accountsresultsdialog----------------------------------------------- -->

    <DialogContainer v-if="createAccountfailed">
      <div class="adm-dialog">
        <div class="adm-dialog-header danger">
          <h3>Invitation failed</h3>
          <button
            type="button"
            class="adm-dialog-close"
            aria-label="Close"
            @click="cancelForm"
          >
            <i class="fa fa-times" />
          </button>
        </div>
        <div class="adm-dialog-body">
          <p v-if="createErrorMessage">{{ createErrorMessage }}</p>
          <p v-else>Something went wrong while sending the invitation.</p>
        </div>
        <div class="adm-dialog-footer">
          <button class="adm-btn-primary" @click="cancelForm">Try again</button>
        </div>
      </div>
    </DialogContainer>

    <DialogContainer v-if="createAccountSuccess">
      <div class="adm-dialog">
        <div class="adm-dialog-header">
          <h3>
            <i class="fa fa-paper-plane invitation-success-icon" />
            Invitation sent
          </h3>
          <button
            type="button"
            class="adm-dialog-close"
            aria-label="Close"
            @click="cancelForm"
          >
            <i class="fa fa-times" />
          </button>
        </div>
        <div class="adm-dialog-body">
          <p>
            An invitation email has been sent.<br />
            The invitee can complete sign-up via the link.
          </p>
        </div>
        <div class="adm-dialog-footer">
          <button class="adm-btn-primary" @click="cancelForm">Done</button>
        </div>
      </div>
    </DialogContainer>

    <!-- ----------- invite dialog ----------- -->
    <DialogContainer v-if="isCreateClicked">
      <div class="adm-dialog">
        <div class="adm-dialog-header">
          <h3>Invite user</h3>
          <button
            type="button"
            class="adm-dialog-close"
            aria-label="Close"
            @click="cancelForm"
          >
            <i class="fa fa-times" />
          </button>
        </div>
        <form @submit.prevent="createItem">
          <div class="adm-dialog-body">
            <p class="adm-dialog-lead">
              The invitee will receive an email link to set their name and
              password.
            </p>
            <div class="dlg-field">
              <label for="invite-email" class="dlg-label">Email</label>
              <input
                v-model="createForm.email"
                id="invite-email"
                type="email"
                placeholder="invitee@example.com"
                class="adm-input dlg-input"
                required
              />
              <span v-if="errors.email" class="adm-error">{{
                errors.email
              }}</span>
            </div>
            <div class="dlg-field">
              <label for="invite-role" class="dlg-label">Role</label>
              <b-form-select
                v-model="createForm.roleId"
                id="invite-role"
                :options="[
                  { value: 2, text: 'Monitor' },
                  { value: 1, text: 'Admin' },
                ]"
                class="dlg-select"
              />
              <span v-if="errors.role" class="adm-error">{{
                errors.role
              }}</span>
            </div>
          </div>
          <div class="adm-dialog-footer">
            <button
              type="button"
              class="adm-btn-ghost"
              :disabled="isLoading"
              @click="cancelForm"
            >
              Cancel
            </button>
            <button
              type="submit"
              class="adm-btn-primary"
              :disabled="isLoading"
            >
              <i v-if="isLoading" class="fa fa-spinner fa-spin" />
              <i v-else class="fa fa-paper-plane" />
              Send invitation
            </button>
          </div>
        </form>
      </div>
    </DialogContainer>
    <!-- ----------- update dialog ----------- -->
    <DialogContainer v-if="isUpdateClicked">
      <div class="adm-dialog">
        <div class="adm-dialog-header">
          <h3>Update account</h3>
          <button
            type="button"
            class="adm-dialog-close"
            aria-label="Close"
            @click="cancelForm"
          >
            <i class="fa fa-times" />
          </button>
        </div>
        <form @submit.prevent="updateItem">
          <div class="adm-dialog-body">
            <p class="adm-dialog-lead">
              Changing the email address requires the user to verify the new
              address before they can sign in again.
            </p>
            <div class="dlg-field">
              <label for="update-name" class="dlg-label">Full name</label>
              <input
                v-model="updateForm.firstName"
                id="update-name"
                type="text"
                placeholder="Full name"
                class="adm-input dlg-input"
                required
              />
            </div>
            <div class="dlg-field">
              <label for="update-email" class="dlg-label">Email</label>
              <input
                v-model="updateForm.email"
                id="update-email"
                type="email"
                placeholder="user@example.com"
                class="adm-input dlg-input"
                required
              />
            </div>
            <div class="dlg-field">
              <label for="update-role" class="dlg-label">Role</label>
              <b-form-select
                v-model="updateForm.userRole"
                id="update-role"
                :options="[
                  { value: 2, text: 'Monitor' },
                  { value: 1, text: 'Admin' },
                ]"
                class="dlg-select"
              />
            </div>
          </div>
          <div class="adm-dialog-footer">
            <button
              type="button"
              class="adm-btn-ghost"
              :disabled="isActionBusy"
              @click="cancelForm"
            >
              Cancel
            </button>
            <button
              type="submit"
              class="adm-btn-primary"
              :disabled="isActionBusy"
            >
              <i v-if="isActionBusy" class="fa fa-spinner fa-spin" />
              <i v-else class="fa fa-check" />
              Save changes
            </button>
          </div>
        </form>
      </div>
    </DialogContainer>
    <!-- ----------- deactivate dialog ----------- -->
    <DialogContainer v-if="isDeactivateClicked">
      <div class="adm-dialog">
        <div class="adm-dialog-header">
          <h3>Deactivate account</h3>
          <button
            type="button"
            class="adm-dialog-close"
            aria-label="Close"
            @click="cancelForm"
          >
            <i class="fa fa-times" />
          </button>
        </div>
        <form @submit.prevent="deactivateItem">
          <div class="adm-dialog-body">
            <p class="adm-dialog-lead">
              <strong>{{ deactivateForm.firstName || "This account" }}</strong>
              will be blocked from signing in. The data and history are
              preserved, and you can re-activate the account at any time.
            </p>
            <p class="deactivate-target">
              <i class="fa fa-envelope" aria-hidden="true" />
              {{ deactivateForm.email }}
            </p>
          </div>
          <div class="adm-dialog-footer">
            <button
              type="button"
              class="adm-btn-ghost"
              :disabled="isActionBusy"
              @click="cancelForm"
            >
              Cancel
            </button>
            <button
              type="submit"
              class="adm-btn-primary"
              :disabled="isActionBusy"
            >
              <i v-if="isActionBusy" class="fa fa-spinner fa-spin" />
              <i v-else class="fa fa-user-slash" />
              Deactivate
            </button>
          </div>
        </form>
      </div>
    </DialogContainer>
    <!-- ----------- delete dialog ----------- -->
    <DialogContainer v-if="isDeleteClicked">
      <div class="adm-dialog">
        <div class="adm-dialog-header danger">
          <h3>Delete account</h3>
          <button
            type="button"
            class="adm-dialog-close"
            aria-label="Close"
            @click="cancelForm"
          >
            <i class="fa fa-times" />
          </button>
        </div>
        <form @submit.prevent="deleteItem">
          <div class="adm-dialog-body">
            <p class="adm-dialog-lead">
              Permanently delete
              <strong>{{ deleteForm.firstName || "this account" }}</strong>
              and revoke its sessions. The email address becomes available for
              a new invitation.
              <br /><em>This action cannot be undone.</em>
            </p>
            <p class="deactivate-target">
              <i class="fa fa-envelope" aria-hidden="true" />
              {{ deleteForm.email }}
            </p>
          </div>
          <div class="adm-dialog-footer">
            <button
              type="button"
              class="adm-btn-ghost"
              :disabled="isActionBusy"
              @click="cancelForm"
            >
              Cancel
            </button>
            <button
              type="submit"
              class="adm-btn-primary danger"
              :disabled="isActionBusy"
            >
              <i v-if="isActionBusy" class="fa fa-spinner fa-spin" />
              <i v-else class="fa fa-trash" />
              Delete
            </button>
          </div>
        </form>
      </div>
    </DialogContainer>

    <div class="adm-toolbar">
      <input
        v-model="textInput"
        placeholder="Search by id, name, or email…"
        class="adm-input search-input"
        aria-label="Search"
      />
      <div class="adm-toolbar-spacer" />
      <button type="button" class="adm-btn-primary" @click="toggleCreateForm">
        <i class="fa fa-paper-plane" /> Invite
      </button>
    </div>

    <div v-if="actionError" class="adm-error-banner" role="alert">
      <i class="fa fa-circle-exclamation" aria-hidden="true" />
      <span>{{ actionError }}</span>
    </div>

    <div v-if="isDataLoading" class="adm-empty">
      <img src="../assets/admin_loading.gif" alt="Loading" class="loader" />
      <div class="adm-empty-sub">Loading accounts…</div>
    </div>

    <div v-else-if="adminUsers.length > 0" class="adm-card">
      <b-table
        id="accounts-table"
        responsive
        :items="adminUsers"
        :fields="fields"
        hover
        small
        :per-page="perPage"
        :current-page="currentPage"
        class="adm-table"
      >
        <template #cell(is_active)="data">
          <span
            class="adm-status"
            :class="data.item.is_active ? 'adm-status-active' : 'adm-status-inactive'"
          >
            {{ data.item.is_active ? "Active" : "Inactive" }}
          </span>
        </template>
        <template #cell(action)="data">
          <!--
            Admin rows (role_id === 1) and the caller's own row are
            intentionally off-limits to all bulk actions. Self-edits live on
            the Profile page; admin promotion/demotion is not supported.
          -->
          <b-dropdown
            v-if="
              !isDialogOpen &&
              currentUser != data.item.id &&
              Number(data.item.role_id) === 2
            "
            right
            no-caret
            variant="link"
            size="sm"
            toggle-class="actions-trigger"
            menu-class="adm-menu"
            boundary="viewport"
            class="row-action-dropdown"
          >
            <template #button-content>
              <span>Actions</span>
              <i class="fa fa-chevron-down actions-caret" />
            </template>
            <b-dropdown-item @click="updateFormData(data.item.id)"
              >Update</b-dropdown-item
            >
            <b-dropdown-item
              v-if="data.item.is_active"
              @click="deactivateFormData(data.item)"
              >Deactivate</b-dropdown-item
            >
            <b-dropdown-item v-else @click="activate(data.item.id)"
              >Activate</b-dropdown-item
            >
            <b-dropdown-item
              @click="deleteFormData(data.item.id)"
              class="text-danger"
              >Delete</b-dropdown-item
            >
          </b-dropdown>
        </template>
      </b-table>
      <div v-if="adminUsers.length > perPage" class="adm-pagination">
        <b-pagination
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          first-number
          last-number
          aria-controls="accounts-table"
        />
      </div>
    </div>

    <div v-else class="adm-empty">
      <div class="adm-empty-icon"><i class="fa fa-user-shield" /></div>
      <div class="adm-empty-title">No matching accounts</div>
      <div class="adm-empty-sub">
        Clear the filter to see all accounts, or invite someone new.
      </div>
    </div>
  </div>
</template>

<script>
import DialogContainer from "@/components/DialogContainer.vue";
import axios from "axios"; // Import Axios
import { API_BASE_URL } from "@/utils/apiBase";
import { customAxios } from "@/utils/customAxios";
import { getAuthItem, getAuthToken } from "@/utils/authStorage";
import { apiErrorMessage } from "@/utils/apiError";
import debounce from "lodash/debounce"; // Import debounce function from lodash

export default {
  components: {
    DialogContainer,
  },
  data() {
    return {
      isDataLoading: true,
      isLoading: false,
      // Guards the row actions against a double submit, and carries the
      // server's reason when one of them fails.
      isActionBusy: false,
      actionError: "",
      perPage: 20,
      currentPage: 1,
      createAccountfailed: false,
      createAccountSuccess: false,
      isCreateClicked: false,
      isUpdateClicked: false,
      isDeleteClicked: false,
      createForm: {
        email: "",
        roleId: 2,
      },
      createErrorMessage: "",
      errors: {
        email: "",
        role: "",
      },
      updateForm: {
        firstName: "",
        lastName: "",
        email: "",
        userRole: "",
        id: "",
      },
      deleteForm: {
        firstName: "",
        lastName: "",
        email: "",
        id: "",
      },
      isDeactivateClicked: false,
      deactivateForm: {
        firstName: "",
        email: "",
        id: "",
      },
      textInput: "",
      fields: [
        { key: "id", label: "ID" },
        { key: "name", label: "Name" },
        { key: "email", label: "Email" },
        {
          key: "role_id",
          label: "Role",
          formatter: (v) => (Number(v) === 1 ? "Admin" : "Monitor"),
        },
        { key: "is_active", label: "Status" },
        { key: "action", label: "" },
      ],
      adminUsers: [],

      currentUser: null,
    };
  },
  watch: {
    textInput: {
      handler: "debouncedFetchAdmins",
      immediate: true,
    },
  },
  computed: {
    // DialogContainer's backdrop is only semi-opaque and sits at z-index 10,
    // so a row's Actions button stays faintly visible — and its open menu
    // (Bootstrap gives .dropdown-menu z-index 1000) would sit on top of the
    // dialog outright. Drop the triggers while any dialog is up. The old
    // version of this covered only the update and delete dialogs.
    isDialogOpen() {
      return (
        this.isCreateClicked ||
        this.isUpdateClicked ||
        this.isDeleteClicked ||
        this.isDeactivateClicked ||
        this.createAccountSuccess ||
        this.createAccountfailed
      );
    },
    rows() {
      return this.adminUsers.length;
    },
  },
  methods: {
    toggleCreateForm() {
      this.isCreateClicked = true;
    },
    validateForm() {
      this.errors.email = this.createForm.email ? "" : "Email is required";
      this.errors.role = this.createForm.roleId ? "" : "Role is required";
    },
    createItem() {
      this.isLoading = true;
      this.createErrorMessage = "";
      this.validateForm();

      if (this.errors.email || this.errors.role) {
        this.isLoading = false;
        return;
      }

      const token = getAuthToken();

      axios
        .post(
          `${API_BASE_URL}/invitations`,
          {
            email: this.createForm.email,
            role_id: this.createForm.roleId,
          },
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        )
        .then(() => {
          this.isCreateClicked = false;
          this.isLoading = false;
          this.createAccountSuccess = true;
          this.createForm.email = "";
          this.createForm.roleId = 2;
        })
        .catch((error) => {
          this.isLoading = false;
          const data = error.response && error.response.data;
          if (data && data.errors) {
            const flat = data.errors;
            this.errors.email = (flat.email && flat.email[0]) || "";
            this.errors.role = (flat.role_id && flat.role_id[0]) || (flat.role && flat.role[0]) || "";
            this.createErrorMessage =
              Object.values(flat).flat().join(" ") || "Invitation failed.";
          } else {
            this.createErrorMessage = "An error occurred. Please try again.";
          }
          this.isCreateClicked = false;
          this.createAccountfailed = true;
          console.error("invitation failed: ", error);
        });
    },
    updateFormData(id) {
      // Handle the update logic
      this.isUpdateClicked = true;
      const token = getAuthToken();
      axios
        .get(`${API_BASE_URL}/get-admin/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          this.updateForm.firstName = response.data.name;
          this.updateForm.email = response.data.email;
          this.updateForm.id = response.data.id;
          this.updateForm.userRole = response.data.role_id;
        })
        .catch((error) => {
          console.error(
            "There was an error fetching the admin accounts!",
            error
          );
        });
      // Implement your update logic here
    },
    closeUpdateDialog() {
      this.isUpdateClicked = false;
      this.updateForm = {
        firstName: "",
        lastName: "",
        email: "",
        userRole: "",
        id: "",
      };
    },
    updateItem() {
      if (this.isActionBusy) return;
      const id = this.updateForm.id;
      this.isActionBusy = true;
      this.actionError = "";
      customAxios
        .post(`/update-admin/${id}`, {
          full_name: this.updateForm.firstName,
          email: this.updateForm.email,
          user_role: parseInt(this.updateForm.userRole, 10),
        })
        .then(() => {
          this.closeUpdateDialog();
          this.fetchAdmins();
        })
        .catch((error) => {
          console.error("Update failed", error);
          // Previously this only console.log'd, so a rejected email or a
          // role-gate refusal left the dialog sitting there with no feedback.
          this.closeUpdateDialog();
          this.actionError = apiErrorMessage(
            error,
            "Could not update this account."
          );
        })
        .finally(() => {
          this.isActionBusy = false;
        });
    },
    deleteFormData(id) {
      // Handle the delete logic
      this.isDeleteClicked = true;
      const token = getAuthToken();

      axios
        .get(`${API_BASE_URL}/get-admin/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          this.deleteForm.firstName = response.data.name;
          this.deleteForm.email = response.data.email;
          this.deleteForm.id = response.data.id;
        }, {})
        .catch((error) => {
          console.error(
            "There was an error fetching the admin accounts!",
            error
          );
        });
      // Implement your delete logic here
    },
    closeDeleteDialog() {
      this.isDeleteClicked = false;
      this.deleteForm = { firstName: "", lastName: "", email: "", id: "" };
    },
    deleteItem() {
      if (this.isActionBusy) return;
      const id = this.deleteForm.id;
      this.isActionBusy = true;
      this.actionError = "";
      customAxios
        .post(`/delete-admin/${id}`)
        .then(() => {
          this.closeDeleteDialog();
          this.fetchAdmins();
        })
        .catch((error) => {
          console.error("Delete failed", error);
          this.closeDeleteDialog();
          this.actionError = apiErrorMessage(
            error,
            "Could not delete this account."
          );
        })
        .finally(() => {
          this.isActionBusy = false;
        });
    },
    deactivateFormData(item) {
      this.deactivateForm.firstName = item.name;
      this.deactivateForm.email = item.email;
      this.deactivateForm.id = item.id;
      this.isDeactivateClicked = true;
    },
    closeDeactivateDialog() {
      this.isDeactivateClicked = false;
      this.deactivateForm = { firstName: "", email: "", id: "" };
    },
    deactivateItem() {
      if (this.isActionBusy) return; // guard against a repeat submit
      const id = this.deactivateForm.id;
      this.isActionBusy = true;
      this.actionError = "";
      customAxios
        .post(`/deactivate-admin/${id}`)
        .then(() => {
          // Refresh the rows rather than reloading the page: $router.go()
          // discarded the search box, the pagination page and the scroll
          // position on every action.
          this.closeDeactivateDialog();
          this.fetchAdmins();
        })
        .catch((error) => {
          console.error("Deactivate failed", error);
          // Close first so the banner isn't hidden behind the dialog.
          this.closeDeactivateDialog();
          this.actionError = apiErrorMessage(
            error,
            "Could not deactivate this account."
          );
        })
        .finally(() => {
          this.isActionBusy = false;
        });
    },
    activate(id) {
      if (this.isActionBusy) return;
      this.isActionBusy = true;
      this.actionError = "";
      customAxios
        .post(`/activate-admin/${id}`)
        .then(() => this.fetchAdmins())
        .catch((error) => {
          console.error("Activate failed", error);
          this.actionError = apiErrorMessage(
            error,
            "Could not activate this account."
          );
        })
        .finally(() => {
          this.isActionBusy = false;
        });
    },
    cancelForm() {
      this.isCreateClicked = false;
      this.isUpdateClicked = false;
      this.isDeleteClicked = false;
      this.isDeactivateClicked = false;
      this.createAccountSuccess = false;
      this.createAccountfailed = false;
      this.deactivateForm = { firstName: "", email: "", id: "" };

      //reset invite form
      this.createForm.email = "";
      this.createForm.roleId = 2;
      this.createErrorMessage = "";

      this.errors = { email: "", role: "" };
    },
    fetchAdmins() {
      this.isLoading = true;
      this.isDataLoading = true;
      const token = getAuthToken();

      axios
        .post(
          `${API_BASE_URL}/get-adminuser`,
          {
            filter: "",
            search: this.textInput,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((response) => {
          // Ensure response data is in correct format
          // Assume response.data is an array of users
          if (Array.isArray(response.data)) {
            this.adminUsers = response.data;
            this.isDataLoading = false;
          } else {
            console.error("API response is not an array:", response.data);
            this.adminUsers = []; // Default to an empty array on error
            this.isDataLoading = false;
          }
        })
        .catch((error) => {
          console.error("There was an error fetching the admins!", error);
          this.adminUsers = []; // Default to an empty array on error
        })
        .finally(() => {
          this.isDataLoading = false;
          this.isLoading = false; // Set loading state to false
        });
    },
    // Debounced fetchUsers method
    debouncedFetchAdmins: debounce(function () {
      this.fetchAdmins();
    }, 300), // Adjust debounce delay as needed (300ms here)
    toggleExportDialog() {
      if (this.cancelTokenSource) {
        this.cancelTokenSource.cancel("Export canceled by user.");
      }
      this.exportToCsv = false;
    },
  },

  mounted() {
    this.currentUser = getAuthItem("userID");
  },
};
</script>

<style scoped>
.invisible {
  display: none;
}

/* ---------- modern dialog (used by invite / success / failure) ---------- */
.adm-dialog {
  background: #ffffff;
  border-radius: 12px;
  width: 100%;
  max-width: 460px;
  box-shadow: 0 16px 40px rgba(16, 24, 40, 0.18);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.adm-dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.85rem 1.1rem;
  background: #f7f8fb;
  border-bottom: 1px solid #eaecf2;
}
.adm-dialog-header.danger {
  background: #fdecee;
  border-bottom-color: #f7c8cf;
}
.adm-dialog-header h3 {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: #1f2540;
  max-width: none;
  font-family: inherit;
  font-weight: 600;
  letter-spacing: 0;
}
.adm-dialog-header.danger h3 {
  color: #b02a37;
}
.adm-dialog-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: transparent;
  border: none;
  border-radius: 8px;
  color: #5b6577;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
}
.adm-dialog-close:hover {
  background: rgba(42, 52, 93, 0.08);
  color: #2a345d;
}
.adm-dialog-body {
  padding: 1.1rem 1.25rem;
}
.adm-dialog-body p {
  margin: 0 0 0.75rem 0;
  color: #5b6577;
  font-size: 0.92rem;
  max-width: none;
  font-family: inherit;
  font-weight: 400;
}
.adm-dialog-body p:last-child {
  margin-bottom: 0;
}
.adm-dialog-lead {
  margin-bottom: 1rem !important;
}
.adm-dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  padding: 0.75rem 1.1rem;
  border-top: 1px solid #eaecf2;
  background: #ffffff;
}

.invitation-success-icon {
  color: #1e7e34;
  margin-right: 0.35rem;
}

/* deactivate confirmation — identifies the account being acted on. Same
   surface tokens as .adm-dialog-header so it reads as part of the dialog. */
.deactivate-target {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  margin: 0.75rem 0 0 0;
  padding: 0.5rem 0.7rem;
  background: #f7f8fb;
  border: 1px solid #eaecf2;
  border-radius: 8px;
  color: #2a345d;
  font-size: 0.9rem;
  word-break: break-all;
}
.deactivate-target i {
  color: #5b6577;
}

/* invite form fields */
.dlg-field {
  display: flex;
  flex-direction: column;
  margin-bottom: 0.85rem;
}
.dlg-field:last-child {
  margin-bottom: 0;
}
.dlg-label {
  font-size: 0.78rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #5b6577;
  margin-bottom: 0.35rem;
  font-family: inherit;
}
.dlg-input,
.dlg-select {
  width: 100%;
  max-width: none;
}
.dlg-select.custom-select {
  height: 38px;
  background-color: #f7f8fb;
  border: 1px solid #e6e8ee;
  border-radius: 8px;
  font-size: 0.9rem;
  color: #1f2540;
}
.dlg-select.custom-select:focus {
  background-color: #ffffff;
  border-color: #2a345d;
  box-shadow: 0 0 0 3px rgba(42, 52, 93, 0.12);
}
.adm-error {
  color: #b02a37;
  font-size: 0.8rem;
  margin-top: 0.25rem;
}
.search-input {
  flex: 1;
  min-width: 12rem;
  max-width: 24rem;
}
#checkboxLabel {
  margin-left: 5px;
}



/*=====================================dropdown menu============================================*/
.b-dropdown-item {
  cursor: pointer;
}





.accountCreationFailed {
  width: 380px;
  border: 1px solid red;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: white;
  height: 30vh;
  padding: 7rem 1rem;
}

.accountCreationFailed > p {
  width: 90%;
}

.accountCreationSuccess {
  width: 380px;
  border: 1px solid black;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: white;
  height: 30vh;
  padding: 7rem 1rem;
}

.accountCreationSuccess > p {
  width: 90%;
}

/* ------------------------loading gif--------------------------------- */
.createAccountloader {
  width: 20px; /* Adjust size as needed */
  height: 20px;
  display: inline-block;
  vertical-align: middle;
}

.error-message {
  color: red;
  font-size: 0.875rem;
  margin-top: 5px;
  margin-bottom: 200px;
}


.loader {
  width: 40px; /* Adjust size as needed */
  height: 40px;
  display: inline-block;
  vertical-align: middle;
  margin-bottom: 1rem;
}

.loading-screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9;
}

.input-section {
  margin-bottom: 2%;
}
</style>
